'use client';

import { GlobalErrorBody, type GlobalErrorProps } from '@libs/shared-ui';

export default function ErrorPage({ error, reset }: GlobalErrorProps) {
    return <GlobalErrorBody reset={reset} error={error} />;
}
